// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__3p3H4","marginSm":"Divider_marginSm__QN5fH","noMargin":"Divider_noMargin__1dPSg"};